<template>
  <el-cascader
    :options="options"
    :props="{
      value: 'Id',
      label: 'Name',
      checkStrictly: true,
      emitPath: false,
    }"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  data () {
    return {
      options: null
    }
  },
  created () {
    this.$apis.organize.dept.list().then(res => {
      this.options = res
    })
  }
}
</script>
